{
  document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".video__box");
    videoBoxes.forEach((box) => {
      const video = box.querySelector("video");
      const playIcon = box.querySelector(".play-btn-hldr");
      box.addEventListener("click", () => {
        document
          .querySelectorAll(".video__box video")
          .forEach((v) => v !== video && v.pause());
        video[video.paused ? "play" : "pause"]();
        playIcon.style.display = video.paused ? "flex" : "none";
      });
      video.addEventListener("play", () => (playIcon.style.display = "none"));
      video.addEventListener("pause", () => (playIcon.style.display = "flex"));
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".tabs_menus_testi li");
    const rows = document.querySelectorAll(".tabs_rows__wrp .testi_video_rows");
    if (tabs.length === 0 || rows.length === 0) return;
    tabs[0].classList.add("active");
    rows[0].classList.add("active");
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", function () {
        tabs.forEach((t) => t.classList.remove("active"));
        rows.forEach((r) => r.classList.remove("active"));
        this.classList.add("active");
        rows[index].classList.add("active");
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const allAccordions = document.querySelectorAll(
      ".faqs__rows .accordion_cus"
    );
    allAccordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(".faqs__rows .acco_cus_item");
      if (items.length > 0) {
        items[0].classList.add("open");
      }
      items.forEach((item) => {
        const header = item.querySelector(".faqs__rows .acc-header");
        header.addEventListener("click", () => {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("open")) {
              otherItem.classList.remove("open");
            }
          });
          item.classList.toggle("open");
        });
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
  const resizeIcons = document.querySelectorAll(".reize_icon");

  resizeIcons.forEach(icon => {
    icon.addEventListener("click", function () {
      const video = icon.closest(".video-media").querySelector("video");

      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen(); // Safari
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen(); // Old IE
      }

      // Auto play when fullscreen
      video.play();
    });
  });
});

}

{
  document.addEventListener("DOMContentLoaded", () => {
  
  const openBtns = document.querySelectorAll(".popupbtnsViews");
  const popups = document.querySelectorAll(".nutrition-popup");
  const closeBtns = document.querySelectorAll(".close-nutrition");

  openBtns.forEach((btn, index) => {
    const popup = popups[index];
    const closeBtn = closeBtns[index];

    // OPEN POPUP
    btn.addEventListener("click", () => {
      popup.style.display = "flex";
    });

    // CLOSE POPUP BY X
    closeBtn.addEventListener("click", () => {
      popup.style.display = "none";
    });

    // CLOSE POPUP BY OUTSIDE CLICK
    popup.addEventListener("click", (e) => {
      if (e.target === popup) {
        popup.style.display = "none";
      }
    });
  });

});

}